import { auth, db } from '../firebase';

import { Form, Link, useLoaderData, useNavigate } from 'react-router-dom';
import l from './landing.module.scss';
import { useEffect } from 'react';
import { getValFrmDict, sdgs, slug } from '../../k4dAdmin/data';

import Spacer from '../components/spacer';
import MyHeader from '../components/header';
import MyFooter from '../components/footer';
import { FaSearch } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import { GrFormNextLink } from 'react-icons/gr';
import { truncateForLink } from '../data';
const articlesCount = 10;

//getTop5Articles

export const landingloader =
  (useApiProviderCtx) =>
  async ({ params, request }) => {
    const { getTop5Articles, getAllSdgPhotos, getBottom3Articles } = useApiProviderCtx;
    let w2 = {};
    //const vex =
    try {
      w2 = await getTop5Articles({});
    } catch (e) {}
    let b = await getAllSdgPhotos(params);

    //getBottom3Articles
    let w3 = {};
    //const vex =
    try {
      w3 = await getBottom3Articles({});
    } catch (e) {}

    return { ...params, recent: { ...w2 }, popular: { ...w3 }, photos: { ...b } };
    //return w2;
  };

export default function Landing() {
  const { lang, recent, photos, popular } = useLoaderData();
  //const sdg={};
  const navigate = useNavigate();

  useEffect(() => {
    console.log({ recent, photos });
  }, [recent]);

  return (
    <>
      <MyHeader />
      <div className={l.whole0}>
        <div className={l.whole}>
          {/*<div className={l.hero}>
            <div className={l.her}>
              <h1>Get SDG Related Articles</h1>
              <p>Follow along with one of our {articlesCount}+ sdg.</p>
            </div>

            <div className={l.her2}>
              <div className={l.inpu}>
                <BsSearch />
                <input type="search" placeholder="search our catalog" />
              </div>

              <p>
                To add a tag to the search, type the tag with [ ] around it. Or, search this query on [questions and
                answers].
              </p>
            </div>
          </div>*/}
          {/*<Spacer />
          currently occuping space so that page content top isn't covered by header*/}
          {/*<div className={l.cta1}>
            <div>Popular Topics</div>
            <div><GrFormNextLink /></div>
          </div>*/}

          {/*
<h1>Featured Content</h1>*/}

          <div className={l.cta2}>
            <h1>Most Recent Content {lang ? lang : 'en'}</h1>
            <a href="/en/most-recent">View All</a>
          </div>

          <div className={l.mrcCon}>
            <div className={l.mrc}>
              {recent?.data?.map((d, i) => {
                return (
                  <div key={i} className={l.mrcItem}>
                    {/*JSON.stringify(d)*/}
                    <img src={photos?.data[d?.primary_tag]?.cover_photo} />
                    <a href={`/${lang ? lang : 'en'}/${d?.primary_tag}`} className={l.primary}>
                      {getValFrmDict(d?.primary_tag)}
                    </a>
                    <a href={`/${lang ? lang : 'en'}/${d?.key}/${truncateForLink(slug(d?.article_title))}`}>
                      <div className={l.title}>{d?.article_title}</div>
                    </a>
                    <div className={l.posted}>{new Date(d?.postedOn).toDateString()}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/*JSON.stringify(recent)*/}

          <div className={l.cta2}>
            <h1>Popular Content</h1>
            <a href="/en/popular">View All</a>
          </div>

          <div className={l.mrcCon}>
            <div className={l.mrc}>
              {popular?.data?.map((d, i) => {
                return (
                  <a key={i} className={l.mrcItem}>
                    {/*JSON.stringify(d)*/}
                    <img src={photos?.data[d?.primary_tag]?.cover_photo} />
                    <a href={`/${lang ? lang : 'en'}/${d?.primary_tag}`} className={l.primary}>
                      {getValFrmDict(d?.primary_tag)}
                    </a>
                    <div className={l.title}>{d?.article_title}</div>
                    <div className={l.posted}>{new Date(d?.postedOn).toDateString()}</div>
                  </a>
                );
              })}
            </div>
          </div>

          <MyFooter />

          {/*<div className={l.foc}>
            <div className={l.focH}>Sustainable Development Goals</div>
            <div className={l.focMap}>
              {sdgs?.map((bn) => {
                return <a href={getValFrmDict(bn?.name)}>{bn?.name}</a>;
              })}
            </div>

            <h1>&nbsp;</h1>
          </div>*/}
        </div>
      </div>

      {/*<div className={l.whole0}>
        <div className={l.whole}>
          <h1>&nbsp;</h1>

          <MyFooter />
        </div>
      </div>*/}
    </>
  );
}
